<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="evgSpuCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="800"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="
        multiple ? { highlight: true, reserve: true, trigger: 'row' } : {}
      "
      :radio-config="
        !multiple
          ? { highlight: true, reserve: true, strict: false, trigger: 'row' }
          : {}
      "
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @radio-change="radioChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:displayImage="{ row }">
        <el-image
          :src="$osscdn(row.defaultImageUrl) || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            $osscdn(row.defaultImageUrl) || '/image/static/img/nopic.jpg',
          ]"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>

      <template v-slot:displayName="{ row }">
        <div>{{ row.goodsName }}</div>
        <div>{{ row.goodsNameEn }}</div>
        <div>
          <span class="mr-2">SPU:</span>
          <span style="color: #409EFF">{{ row.evgSpuNo }}</span>
        </div>
      </template>

      <template v-slot:displayBrand="{ row }">
        <div v-if="row.brandName">
          <span class="mr-2">BRAND:</span>
          <span>{{ row.brandName }}</span>
        </div>
        <div v-if="row.categoryFullName">
          <span class="mr-2">CATEGORY:</span>
          <span>{{ row.categoryFullName }}</span>
        </div>
        <div v-if="row.collectionName">
          <span class="mr-2">COLLECTION:</span>
          <span>{{ row.collectionName }}</span>
        </div>
      </template>

      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createDate }}</div>
      </template>

      <template v-slot:displayModify="{ row }">
        <div>{{ row.modifyByName }}</div>
        <div>{{ row.modifyDate }}</div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('change', records.concat(reserves))
    },
    radioChange({ newValue }) {
      this.$emit('change', newValue)
    },
  },
}
</script>
